import React from 'react';
import Box from '@mui/material/Box';

import { mediumGray } from 'utils/color-styles';
import { Modal, ModalContents, ModalTitle } from 'components/Modal/Modal';
import { BackButton } from 'retired/BackButtonLayout/BackButton';

import { CommunityFull } from '../types';

import { Lead } from './Lead';

export const LeadsModal = ({
  onClickClose,
  leads,
}: {
  onClickClose: () => void;
  leads: CommunityFull['leads'];
}) => (
  <Modal open fullWidth onClose={onClickClose}>
    <ModalContents
      onClickClose={onClickClose}
      body={
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <BackButton onClick={onClickClose} />
            <ModalTitle style={{ marginBottom: 0, marginLeft: 12 }}>
              Community Leads ({leads.length})
            </ModalTitle>
          </div>
          <Box paddingTop={4}>
            <div>
              {leads.map((lead) => (
                <div
                  key={lead.User.id}
                  style={{
                    borderBottom: `1px solid ${mediumGray}`,
                  }}
                >
                  <Lead key={lead.User.id} lead={lead} full />
                </div>
              ))}
            </div>
          </Box>
        </div>
      }
    />
  </Modal>
);
